import {
  Box,
  Checkbox,
  Inline,
  Input,
  Link,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';

import type { AddContractorLiabilityShieldFields } from '../../types';

const MISCLASSIFICATION_ASSESSMENT_URL =
  'https://omnipresentgroup.typeform.com/to/t24Kn2FT';

const CONTRACT_TEMPLATE_URL =
  'https://drive.google.com/drive/folders/1h3ullUpsOxAckaUWbT_5fZgMR9CqdJNi';

type Props = {
  values: AddContractorLiabilityShieldFields;
  setValues: (values: AddContractorLiabilityShieldFields) => void;
};

export const AddContractorLiabilityShieldRequirements = ({
  values,
  setValues,
}: Props) => (
  <Stack gap="32">
    <Stack gap="16">
      <Typography as="h3" size="16" weight="medium" hideParagraphSpacing>
        OmniProtect Requirements
      </Typography>
      <Box>
        <Typography as="span" size="14">
          In order to be eligible for coverage under OmniProtect, you will need
          to take the misclassification assessment for each contractor and get a
          Low or Medium score, and use our contract template to sign agreement
          with your contractor without any amendment. If you don't find the
          right country on the contract template, reach out to{' '}
        </Typography>
        <Typography as="span" size="14" textDecoration="underline">
          help@omnipresent.com
        </Typography>
        <Typography as="span" size="14">
          {' '}
          and our team will be in touch.
        </Typography>
      </Box>
    </Stack>
    <Stack>
      <Inline gap="4">
        <Checkbox
          id="misclassification-assessment"
          checked={values.misClassificationAssessmentFilled || false}
          onCheckedChange={(checked: boolean) => {
            setValues({
              ...values,
              misClassificationAssessmentFilled: checked,
              misClassificationAssessmentCode: '',
              contractTemplateUsageAccepted: false,
            });
          }}
        />

        <Typography as="label" size="14" htmlFor="misclassification-assessment">
          I have filled in the{' '}
          <Link size="14" to={MISCLASSIFICATION_ASSESSMENT_URL} target="blank">
            misclassification assessment
          </Link>{' '}
          and scored a Low-Medium.
        </Typography>
      </Inline>

      {values.misClassificationAssessmentFilled && (
        <Stack gap="32">
          <Input
            id="misclassification-assessment-code"
            label="Misclassifcation assessment code"
            placeholder="Please enter your code"
            helperText="This code you will have received after completing the misclassification assessment."
            onChange={(event) =>
              setValues({
                ...values,
                misClassificationAssessmentCode: event.target.value,
              })
            }
            value={values.misClassificationAssessmentCode}
          />
          <Inline gap="4">
            <Checkbox
              id="contract-template-usage"
              checked={values.contractTemplateUsageAccepted}
              onCheckedChange={(checked: boolean) => {
                setValues({
                  ...values,
                  contractTemplateUsageAccepted: checked,
                });
              }}
            />
            <Typography as="label" size="14" htmlFor="contract-template-usage">
              I am aware that I need to use an{' '}
              <Link size="14" to={CONTRACT_TEMPLATE_URL} target="blank">
                Omnipresent contract template
              </Link>{' '}
              without amendment to be eligible for coverage.
            </Typography>
          </Inline>
        </Stack>
      )}
    </Stack>
  </Stack>
);
